import {Component, ComponentRef, EventEmitter, Input, Output, reflectComponentType, Type, ViewChild, ViewContainerRef} from '@angular/core';

@Component({
  selector: 'app-modal-wrapper',
  templateUrl: './modal-wrapper.component.html',
  styleUrls: ['./modal-wrapper.component.scss'],
  standalone: false,
})
export class ModalWrapperComponent<T = unknown> {
  @Input() component!: Type<T>;
  @Input() componentProps: T;
  @Input() cssClass?: string | string[];
  @Input() backdropDismiss = true;

  @Output() readonly willDismiss$ = new EventEmitter<T>();

  @ViewChild('modalContent', {read: ViewContainerRef, static: true})
  modalContentRef!: ViewContainerRef;

  private innerComponentRef!: ComponentRef<T>;

  isVisible = false;

  present(): void {
    this.isVisible = true;
    this.innerComponentRef =
      this.modalContentRef.createComponent(this.component);

    this.applyComponentProps((this.componentProps ?? {}) as Record<string, unknown>);
    this.innerComponentRef.changeDetectorRef.detectChanges();
  }

  /**
   * Applies modal componentProps using setInput for declared @Input()/input() bindings
   * and instance assignment for plain fields (legacy modal props).
   */
  private applyComponentProps(props: Record<string, unknown>): void {
    const declaredInputNames = new Set<string>();
    const mirror = reflectComponentType(this.component as Type<object>);
    for (const input of mirror?.inputs ?? []) {
      declaredInputNames.add(input.propName);
      declaredInputNames.add(input.templateName);
    }

    const instance = this.innerComponentRef.instance as Record<string, unknown>;
    for (const [key, value] of Object.entries(props)) {
      if (declaredInputNames.has(key)) {
        this.innerComponentRef.setInput(key, value);
      } else {
        instance[key] = value;
      }
    }
  }


  dismiss(data?: T): void {
    this.isVisible = false;
    setTimeout(() => {
      this.willDismiss$.emit(data);
    }, 200);
  }

  onBackdropClick(): void {
    if (this.backdropDismiss) {
      this.dismiss();
    }
  }

  getCssClass(): string {
    if (Array.isArray(this.cssClass)) {
      return this.cssClass.join(' ');
    } else {
      return this.cssClass;
    }
  }
}
